// Native
import { useState } from "react"

// Components
import { ButtonGroup, Td, Tr } from "@chakra-ui/react"
import { Dash, Icon, IconButton, Scope, Section, Table } from "components"

// Config
import { Moment } from "config"

// Screens
import Delete from "./delete"

export default function Addresses({ data, refetch = () => {} }){

    const [ address, setAddress ] = useState(false) 

    // Table columns
    const columns = [
        { children: 'Cidade' }, 
        { children: 'Endereço' }, 
        { children: 'Complemento' }, 
        { children: 'CEP', isNumeric: true }, 
        { children: '', isNumeric: true }
    ]

    return(
    <>
        <Section title="Endereços do consultor" />

        {/* Table */}
        <Table columns={columns} children={ data?.customer?.addresses?.map(item => <Item data={item} onDelete={setAddress} />)} />

        {/* Screens */}
        <Delete isOpen={!!address} onClose={() => setAddress(false)} data={{ address, consultant: data }} onSuccess={refetch} />
    </>
    )
}

const Item = ({ data:item, onDelete }) => (
    <Tr key={item.id}>
        <Td children={`🗺️ ${item?.city?.name}, ${item?.city?.state_code}`} />
        <Td children={`${item.line_1} ${item.line_2 ?? ''} - ${item.neighborhood ?? ''} (${item.number})`} />
        <Td children={item.complement ?? <Dash />} />
        <Td isNumeric children={item?.zip} />
        <Td isNumeric>
            <ButtonGroup size="xs" variant="outline">
                <IconButton label="Ver no mapa" icon="map" />
                {/* <Scope role="manage_consultants"><IconButton label="Remover endereço" colorScheme="red" icon="trash" onClick={() => onDelete(item)} /></Scope> */}
            </ButtonGroup>
        </Td>
    </Tr>
)